import { RootState } from 'app/store';

export const selectAclConditions = (state: RootState) => state.aclConditions.aclConditions;
export const selectAclConditionsLoaded = (state: RootState) => state.aclConditions.loaded;
